export default __webpack_public_path__ + "static/media/lb-ag.9108e37f.webp";